import qs from 'qs';

const getQueryParam = key => {
  if (typeof window === 'undefined') return '';
  const search = window.location.search.substring(1);

  if (!search.length) {
    return null;
  }

  return qs.parse(search)[key];
};

export default getQueryParam;
